import * as React from "react"
import {Layout} from "../../components/layout"
import {graphql, Link} from "gatsby"
import {GatsbyImage} from "gatsby-plugin-image"

const IndexPage = (props) => {
    const data = props.data.dataYaml.wurfplanung
    return (
        <>
            <Layout title='Wurfplanung'>
                <main className='container'>
                    <h1 className='mb-5'>Wurfplanung</h1>
                    {/*<GatsbyImage
                        image={data.img.childImageSharp.gatsbyImageData}
                        alt={"Litter Car"}
                        className='shadow'
                        loading='lazy'
                    />
                    <GatsbyImage
            image={data.img.childImageSharp.gatsbyImageData}
            alt={"Anjuly mit Welpen"}
            className='shadow'
            loading='lazy'
          />
          <br />
          <p>
            Ein Traum geht in Erfüllung! Ein Deckruede aus meiner Zucht wird
            Papa. Dies wird ein ganz besonderer Wurf. Für seine ersten Kinder
            habe ich meine sanfte Anjuly gewählt - ein Traumpaar.
          </p>
          <p>
            Am 24.02.23 schenkte uns Anjuly 2 prächtige Rueden und 6 ganz
            bezaubernde cremefarben Hündinnen". Geburtsgewichte liegen zwischen
            410 und 470 g! Anjuly und den Kleinen geht es sehr gut.
          </p>
          <p>
            Mein besonderer Dank geht an Fr. Dr. Wisniewski und Fr. Dr. Lorenzi
            sowie dem ganzen Team des Kleintierzentrums Iffezheim für die
            großartigen Hilfe. DANKE Wir freuen uns auf die kommenden 8 Wochen.
          </p>
          <p>Alle Welpen sind schon vergeben.</p>
          <p>
            Ich freue mich riesig - zusammen mit seiner Besitzerin Vanessa
            Strittmatter - Anjuly ist tragend!!!
          </p>
          <p>Die Welpen werden Ende Februar erwartet.</p>
          <p>
            Falls Sie ersthaftes Interesse an einem Welpen aus dieser Verpaarung
            haben, melden Sie sich gerne bei mir.</p>
          <Pedigree
            father={data.father}
            mother={data.mother}
            useImage={false}
          />*/}
                    <p>wir planen für Anfang 2027 einen Wurf mit unserer sanften Enya. Der passende Deckrüde ist noch
                        nicht ausgewählt. Falls Sie ernsthaftes Interesse an einem Welpen haben, melden Sie sich gerne
                        telefonisch oder mit einer aussagekräftigen E-mail bei mir. Die Welpenliste ist bereits
                        geöffnet</p>
                    {/*<GatsbyImage
                        image={data.img.childImageSharp.gatsbyImageData}
                        alt={"Littercard"}
                        className='shadow'
                        loading='lazy'
                    />
                    <p>
                        Enya wurde von CH Perfect Passion Sweet Potato Pie- Luigi- gedeckt.
                    </p>
                    <p>Luigi passt hervorragend zu ihr. Er hat ein so sanftes Wesen, ein traumhaftes Aussehen und top
                        Gesundheitswerte.
                    </p>
                    <p>Danke liebe Petra Theurer für Luigi und für deine Gastfreundschaft.
                        Ich freue mich sehr auf die Kleinen.
                    </p>
                    <p>Die Babys von Luigi und Enya sind da!
                        Letzte Woche hat Enya problemlos ihre Babys bekommen. Zwei prächtige Jungs und zwei zauberhafte
                        Mädchen. Mutter und Kinder sind wohlauf. Näheres unter <Link to={'/zucht/wuerfe/twurf'}>T-Wurf</Link></p>
                    <p>Alle Welpen sind bereits vergeben.
                    </p>
                    {/*<p>Falls Sie ernsthaftes Interesse an einem Welpen aus diesem Wurf haben, melden Sie sich gerne
                        telefonisch bei mir {" "}
                        <a href='tel:+4972469418513'>07246-941 851 3</a> oder schreiben Sie mir eine aussagekräftige
                        E-mail.
                    </p>*/}
                    {/*<p>
          <p>Näheres unter <Link to="/zucht/wuerfe/rwurf/">R-Wurf</Link></p>
            <p>Falls Sie ernsthaftes Interesse an einem Welpen aus dieser
            Verpaarung haben, melden Sie sich bitte mit einer aussagekräftigen
            E-mail oder rufen Sie mich an.{" "}
            <a href='tel:+4972469418513'>07246-941 851 3</a>
</p> <br/><br/>
                    <p>Für diesen Wurf haben wir uns für den wunderschönen goldfarbenen Rüden von Ulrike Stahl "Wild
                        Pepper Quizzmaster" entschieden. Er passt hervorragend zu meiner sanften Anjuly. Seine
                        Gesundheitsergebnisse und vor allem sein Charm sprechen für sich. Ein Prachtkerl. Die beiden
                        haben sich gleich verstanden. Nun hoffen wir, dass unser Ausflug nach Lennestadt Früchte
                        getragen hat.
                    </p>
                    <p>Vielen lieben Dank Ulrike für Deine Gastfreundschaft und für Philippe. Wir haben uns bei Euch
                        sehr wohl gefühlt.
                    </p>
                    <p>Falls Sie ernsthaftes Interesse an einem Welpen aus diesem Wurf haben, melden Sie sich bitte
                        telefonisch bei mir. <a href={'tel:072469418513'}>07246/9418513</a></p>*/}
                </main>
            </Layout>
        </>
    )
}

export const query = graphql`
query WurfplanungPageQuery {
    dataYaml
    {
        wurfplanung
        {
            img
            {
                childImageSharp
                {
                    gatsbyImageData(layout
                :
                    FULL_WIDTH
                )
                }
            }
            father
            {
                normalName
                img
                {
                    childImageSharp
                    {
                        gatsbyImageData(layout
                    :
                        FULL_WIDTH
                    )
                    }
                }
                father
                {
                    father
                    {
                        name
                    }
                    mother
                    {
                        name
                    }
                    name
                }
                mother
                {
                    father
                    {
                        name
                    }
                    mother
                    {
                        name
                    }
                    name
                }
                name
            }
            mother
            {
                normalName
                img
                {
                    childImageSharp
                    {
                        gatsbyImageData(layout
                    :
                        FULL_WIDTH
                    )
                    }
                }
                father
                {
                    father
                    {
                        name
                    }
                    mother
                    {
                        name
                    }
                    name
                }
                name
                mother
                {
                    father
                    {
                        name
                    }
                    mother
                    {
                        name
                    }
                    name
                }
            }
        }
    }
}
`

export default IndexPage
